import { render, staticRenderFns } from "./SecurityTab.vue?vue&type=template&id=0cb287fa&scoped=true"
import script from "./SecurityTab.vue?vue&type=script&lang=js"
export * from "./SecurityTab.vue?vue&type=script&lang=js"
import style0 from "./SecurityTab.vue?vue&type=style&index=0&id=0cb287fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb287fa",
  null
  
)

export default component.exports